import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Typography, CircularProgress, Alert, Button } from '@mui/material';
import { useAuth0 } from '@auth0/auth0-react';

const AuthCallback = () => {
  const navigate = useNavigate();
  const { isAuthenticated, isLoading, error } = useAuth0();
  const [localError, setLocalError] = useState(null);

  useEffect(() => {
    // Wait for Auth0 to process the callback
    if (!isLoading) {
      if (isAuthenticated) {
        console.log('Auth0 callback successful, redirecting to main app');
        navigate('/', { replace: true });
      } else if (error) {
        console.error('Auth0 callback error:', error);
        setLocalError(`Authentication failed: ${error.message}`);
      } else {
        console.warn('Auth0 callback completed but user not authenticated');
        setLocalError('Authentication failed. Please try logging in again.');
      }
    }
  }, [isAuthenticated, isLoading, error, navigate]);

  if (isLoading) {
    return (
      <Box 
        display="flex" 
        flexDirection="column"
        alignItems="center" 
        justifyContent="center" 
        minHeight="100vh"
        gap={2}
      >
        <CircularProgress size={60} />
        <Typography variant="h6">
          Completing authentication...
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Please wait while we process your Strava authorization.
        </Typography>
      </Box>
    );
  }

  if (localError) {
    return (
      <Box 
        display="flex" 
        flexDirection="column"
        alignItems="center" 
        justifyContent="center" 
        minHeight="100vh"
        gap={2}
        p={3}
      >
        <Alert severity="error" sx={{ maxWidth: 500 }}>
          <Typography variant="h6" gutterBottom>
            Authentication Error
          </Typography>
          <Typography variant="body2">
            {localError}
          </Typography>
        </Alert>
        <Box display="flex" gap={2}>
          <Button 
            variant="contained" 
            onClick={() => navigate('/', { replace: true })}
          >
            Go to Main App
          </Button>
          <Button 
            variant="outlined" 
            onClick={() => window.location.reload()}
          >
            Try Again
          </Button>
        </Box>
      </Box>
    );
  }

  return null;
};

export default AuthCallback;
